import { StrictMode,Suspense,lazy } from 'react'
import { createRoot } from 'react-dom/client'
import './shell.css'
const Portal=lazy(()=>import('./portal/App').then(module=>({default:module.PortalApp})))
const Admin=lazy(()=>import('./admin/AdminApp'))
const root=document.getElementById('root')
if(!root)throw new Error('Missing #root mount point')
const admin=/^\/admin(?:\/|$)/.test(location.pathname)
createRoot(root).render(<StrictMode><Suspense fallback={<main className="shell-loading" role="status">{admin?'正在载入管理中心…':'正在展开星海…'}</main>}>{admin?<Admin/>:<Portal/>}</Suspense></StrictMode>)
